import {
  DeleteSourceImagePresetResponseDto,
  PagedSourceImagePresetsRequestDto,
  PagedSourceImagePresetsResponseDto,
  SetSourceImagePresetFavouriteDto,
  SourceImagePresetDto,
  UpdateSourceImagePresetDto,
} from "@repo/api/source-image-preset";
import { AmplifilesClient } from "./api-client";

export class SourceImagePresetApi {
  static async getPagedSourceImagePresets(
    teamExternalId: string,
    body: PagedSourceImagePresetsRequestDto,
  ): Promise<PagedSourceImagePresetsResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/source-image-presets-paged`,
      body,
    );

    return PagedSourceImagePresetsResponseDto.parse(response.data);
  }

  static async updateSourceImagePreset(
    teamExternalId: string,
    presetExternalId: string,
    data: UpdateSourceImagePresetDto,
  ): Promise<SourceImagePresetDto> {
    const response = await AmplifilesClient.instance.put(
      `/team/${teamExternalId}/source-image-preset/${presetExternalId}`,
      data,
    );

    return SourceImagePresetDto.parse(response.data);
  }

  static async deleteSourceImagePreset(
    teamExternalId: string,
    presetExternalId: string,
  ): Promise<DeleteSourceImagePresetResponseDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/source-image-preset/${presetExternalId}`,
    );

    return DeleteSourceImagePresetResponseDto.parse(response.data);
  }

  static async setSourceImagePresetFavourite(
    teamExternalId: string,
    presetExternalId: string,
    data: SetSourceImagePresetFavouriteDto,
  ): Promise<SourceImagePresetDto> {
    const response = await AmplifilesClient.instance.put(
      `/team/${teamExternalId}/source-image-preset/${presetExternalId}/favourite`,
      data,
    );

    return SourceImagePresetDto.parse(response.data);
  }
}
